export default __webpack_public_path__ + "static/media/postgresql-logo.bf3b2c3d.png";